import {Component, OnInit, AfterViewInit, OnDestroy, ChangeDetectorRef} from "@angular/core";
import {CurrentEventService} from "../../../services/communication/currentEventService";
import {ActivatedRoute, Router} from "@angular/router";
import {BusinessService} from "../../../services/data/business.service";
import {FamilyAlbum} from "../../../model/family-album";
import {Picture} from "../../../model/picture";
import {Page} from "../../../model/page";
import {UrlService} from "../../../services/url.service";
import {PhotoSwipeService} from "../../photoswipe/photo-swipe.service";
import {NavBarService} from "../../../services/communication/nav-bar.service";
import {Subscription} from "rxjs";
import {Tweet} from "../../../model/social/tweet";

declare const $: any;
declare const document: any;

@Component({
  selector: 'event-validation',
  template: require('./event-validation.component.html'),
  styles: [
    require('./event-validation.component.scss')
  ]
})

export class EventValidationComponent implements OnInit, AfterViewInit, OnDestroy {

  showingTab = 'photos';

  selectEnabled: boolean = true;
  selectTweetEnabled: boolean = true;

  prev: any;

  PAGE_SIZE: number = 25;

  eventId: number;

  event: FamilyAlbum;

  isSelecting: boolean = false;

  isSelectingTweet: boolean = false;

  isLoadingPicture: boolean = false;

  picturesModel: Picture[] = new Array<Picture>();
  picturePage: Page<Picture> = null;
  picturePageNumber = 0;

  moderatingPictures: number[] = new Array();

  isLoadingTweet: boolean = false;

  tweetsModel: Tweet[] = new Array<Tweet>();
  tweetPage: Page<Tweet> = null;
  tweetPageNumber = 0;

  moderatingTweets: number[] = new Array();

  needsRefresh: boolean = false;

  needsTweetRefresh: boolean = false;

  nbNew = 0;

  nbNewTweets = 0;

  refreshIntervalId: any;

  private paramSubscription: Subscription = null;

  ngOnDestroy(): void {
    this.navBarService.changeBackground(false);
    clearInterval(this.refreshIntervalId);
    this.paramSubscription.unsubscribe();
  }

  ngAfterViewInit(): void {
    let that = this;
// this creates the selected variable
// we are going to store the selected objects in here
    var selected = $([]), offset = {top: 0, left: 0};

    $("#selectable").selectable({
      filter: ".picture-container",
      selecting: function (e, ui) {
        let curr = $(ui.selecting.tagName, e.target).index(ui.selecting);

        if (e.shiftKey && this.prev > -1) {
          $(ui.selecting.tagName, e.target).slice(Math.min(this.prev, curr), 1 + Math.max(this.prev, curr)).addClass('ui-selected');
          this.prev = -1;
        } else {
          this.prev = curr;
        }
      },
      selected: function (e, ui) {
        that.selectPictures();
      },
      unselected: function (e, ui) {
        that.selectPictures();
      }
    });

    $("#selectable-tweets").selectable({
      filter: ".tweet-container",
      selecting: function (e, ui) {
        let curr = $(ui.selecting.tagName, e.target).index(ui.selecting);

        if (e.shiftKey && this.prev > -1) {
          $(ui.selecting.tagName, e.target).slice(Math.min(this.prev, curr), 1 + Math.max(this.prev, curr)).addClass('ui-selected');
          this.prev = -1;
        } else {
          this.prev = curr;
        }
      },
      selected: function (e, ui) {
        that.selectTweets();
      },
      unselected: function (e, ui) {
        that.selectTweets();
      }
    });

    this.disableSelectable();
    this.disableTweetSelectable();
  }


  ngOnInit() {
    this.paramSubscription = this.activatedRoute.params.subscribe(
      (param: any) => {
        this.eventId = param['eventId'];

        this.businessService.getEvent(this.eventId).subscribe(
          event => this.eventLoaded(event)
        );
      });

    this.navBarService.changeBackground(true);
  }

  constructor(private activatedRoute: ActivatedRoute, private currentEventService: CurrentEventService,
              private businessService: BusinessService, private navBarService: NavBarService,
              private urlService: UrlService, private photoSwipeService: PhotoSwipeService,
              private router: Router, private changeDetectorRef: ChangeDetectorRef) {

    let that = this;

    $(document).on('click', '.item', function (event) {
      if (!that.selectEnabled) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    });

    this.launchFetching();
  }

  back() {
    this.router.navigateByUrl('/event/' + this.event.id);
  }

  eventLoaded(event: FamilyAlbum) {
    this.event = event;

    this.loadPictures(1);
    this.loadTweets(1);
  }

  loadPictures(page?: number) {
    this.isLoadingPicture = true;
    this.needsRefresh = false;

    if (page == null) {
      this.picturePageNumber++;
    } else {
      this.picturePageNumber = page;
    }

    this.businessService.eventPicturesToModerate(this.event.id, this.picturePageNumber, this.PAGE_SIZE).subscribe(
      page => this.picturesLoaded(page)
    );
  }

  loadTweets(page?: number) {
    this.isLoadingTweet = true;
    this.needsTweetRefresh = false;

    if (page == null) {
      this.tweetPageNumber++;
    } else {
      this.tweetPageNumber = page;
    }

    this.businessService.eventTweetsToModerate(this.event.id, this.tweetPageNumber, this.PAGE_SIZE).subscribe(
      page => this.tweetsLoaded(page)
    );
  }

  loadIntervalPictures() {
    this.isLoadingPicture = true;

    this.businessService.eventPicturesToModerate(this.event.id, 1, 1).subscribe(
      page => this.intervalPicturesLoaded(page)
    );
  }

  loadIntervalTweets() {
    this.isLoadingTweet = true;

    this.businessService.eventTweetsToModerate(this.event.id, 1, 1).subscribe(
      page => this.intervalTweetsLoaded(page)
    );
  }

  selectPictures() {
    let length = $('.ui-selected.picture-container').length;

    if (length > 0) {
      this.isSelecting = true;
    } else {
      this.isSelecting = false;
    }

    this.changeDetectorRef.detectChanges();
  }

  selectTweets() {
    let length = $('.ui-selected.tweet-container').length;

    if (length > 0) {
      this.isSelectingTweet = true;
    } else {
      this.isSelectingTweet = false;
    }

    this.changeDetectorRef.detectChanges();
  }

  pictureClick(picture: Picture) {
    if (!this.selectEnabled) {
      this.openPicture(picture);
    } else {
      this.selectPictures();
    }
  }

  onScroll() {
    if (!this.isLoadingPicture && this.picturePage != null && !this.picturePage.last) {
      this.loadPictures();
    }
  }

  onTweetScroll() {
    if (!this.isLoadingTweet && this.tweetPage != null && !this.tweetPage.last) {
      this.loadTweets();
    }
  }

  picturesLoaded(page: Page<Picture>) {
    this.picturePage = page;

    if (this.picturePageNumber == 1) {
      this.picturesModel = new Array<Picture>();
    }

    for (let picture of page.content) {
      picture.miniatureUrl = this.urlService.getPictureMiniatureUrl(this.eventId, picture.id);
      picture.url = this.urlService.getPictureUrl(this.eventId, picture.id);
      if (picture.owner != null) {
        picture.owner.avatarUrl = this.urlService.getMemberAvatarUrl(picture.owner.id);
      }

      this.picturesModel.push(picture);
    }

    this.isLoadingPicture = false;
    this.nbNew = 0;

    this.renderFlexImages();
  }

  tweetsLoaded(page: Page<Tweet>) {
    this.tweetPage = page;

    if (this.tweetPageNumber == 1) {
      this.tweetsModel = new Array<Tweet>();
    }

    for (let tweet of page.content) {
        for(let media of tweet.medias) {
          media.miniatureUrl = media.url;
        }

        this.tweetsModel.push(tweet);
    }

    this.isLoadingTweet = false;
    this.nbNewTweets = 0;
  }

  intervalPicturesLoaded(page: Page<Picture>) {
    if(this.picturesModel.length==0) {
      this.picturesLoaded(page);
    } else {
      if (this.picturePage.totalElements < page.totalElements) {
        this.needsRefresh = true;
        this.nbNew = page.totalElements - this.picturePage.totalElements;
        this.picturePage.totalElements = page.totalElements;
      }
    }
  }

  intervalTweetsLoaded(page: Page<Tweet>) {
    if(this.tweetsModel.length==0) {
      this.tweetsLoaded(page);
    } else {
      if (this.tweetPage.totalElements < page.totalElements) {
        this.needsTweetRefresh = true;
        this.nbNewTweets = page.totalElements - this.tweetPage.totalElements;
        this.tweetPage.totalElements = page.totalElements;
      }
    }
  }

  renderFlexImages() {
    this.changeDetectorRef.detectChanges();

    if (this.picturesModel.length > 0) {
      let $flex = $('.flex-images');
      let rowHeight = 250;

      if ($(window).width() < 780) {
        rowHeight = 150;
      }

      if ($flex !== undefined && $flex != null) {
        setTimeout(() => {
          $('.flex-images').flexImages({rowHeight: rowHeight});
        }, 50);
      }
    }
  }

  openPicture(picture) {
    this.photoSwipeService.openGallery([picture], false, 0);
  }

  openTweet(tweet: Tweet, index: number) {
    let pictures = new Array<Picture>();

    for(let media of tweet.medias) {
      let picture = new Picture();
      picture.url = media.url;
      picture.miniatureUrl = media.url;
      picture.height = media.height;
      picture.width = media.width;

      pictures.push(picture);
    }

    this.photoSwipeService.openGallery(pictures, false, index);
  }

  openModal() {
    this.changeDetectorRef.detectChanges();
  }

  enableSelectable() {
    if (!this.selectEnabled) {
      $("#selectable").selectable({
        disabled: false
      });

      this.selectEnabled = true;
      this.isSelecting = false;
    }
  }

  disableSelectable() {
    if (this.selectEnabled) {
      $("#selectable").selectable({
        disabled: true
      });

      this.selectEnabled = false;

      $('.item').removeClass('ui-selected');
    }
  }

  enableTweetSelectable() {
    if (!this.selectTweetEnabled) {
      $("#selectable-tweets").selectable({
        disabled: false
      });

      this.selectTweetEnabled = true;
      this.isSelectingTweet = false;
    }
  }

  disableTweetSelectable() {
    if (this.selectTweetEnabled) {
      $("#selectable-tweets").selectable({
        disabled: true
      });

      this.selectTweetEnabled = false;

      $('.item').removeClass('ui-selected');
    }
  }

  refusePictures() {
    let pictures = [];

    $('.ui-selected.picture-container').each(function () {
      pictures.push(Number($(this).attr('data-id')));
    });

    this.picturesModel = this.picturesModel.filter(picture => {
      return pictures.indexOf(picture.id) == -1;
    });

    this.moderatingPictures = pictures;
    this.businessService.moderateRefusePictures(this.event.id, pictures).subscribe(
      state => {
        this.isSelecting = false;

        this.moderationDone();
      }
    );
  }

  refuseTweets() {
    let tweets = [];

    $('.ui-selected.tweet-container').each(function () {
      tweets.push(Number($(this).attr('data-id')));
    });

    this.tweetsModel = this.tweetsModel.filter(tweet => {
      return tweets.indexOf(tweet.id) == -1;
    });

    this.moderatingTweets = tweets;
    this.businessService.moderateRefuseTweets(this.event.id, tweets).subscribe(
      state => {
        this.isSelectingTweet = false;

        this.tweetModerationDone();
      }
    );
  }

  acceptPictures() {
    let pictures = [];

    $('.ui-selected.picture-container').each(function () {
      pictures.push(Number($(this).attr('data-id')));
    });

    this.picturesModel = this.picturesModel.filter(picture => {
      return pictures.indexOf(picture.id) == -1;
    });

    this.moderatingPictures = pictures;
    this.businessService.moderateAcceptPictures(this.event.id, pictures).subscribe(
      state => {
        this.isSelecting = false;

        this.moderationDone();
      }
    );
  }

  acceptTweets() {
    let tweets = [];

    $('.ui-selected.tweet-container').each(function () {
      tweets.push(Number($(this).attr('data-id')));
    });

    this.tweetsModel = this.tweetsModel.filter(tweet => {
      return tweets.indexOf(tweet.id) == -1;
    });

    this.moderatingTweets = tweets;
    this.businessService.moderateAcceptTweets(this.event.id, tweets).subscribe(
      state => {
        this.isSelectingTweet = false;

        this.tweetModerationDone();
      }
    );
  }

  selectPicture(picture: Picture, event: any) {
    event.stopImmediatePropagation();
    this.moderatingPictures = [picture.id];
  }

  selectTweet(tweet: Tweet, event: any) {
    event.stopImmediatePropagation();
    this.moderatingTweets = [tweet.id];
  }

  acceptSelected() {
    this.businessService.moderateAcceptPictures(this.event.id, this.moderatingPictures).subscribe(
      state => {
        this.moderationDone();
      }
    );
  }

  refuseSelected() {
    this.businessService.moderateRefusePictures(this.event.id, this.moderatingPictures).subscribe(
      state => {
        this.moderationDone();
      }
    );
  }

  acceptTweetSelected() {
    this.businessService.moderateAcceptTweets(this.event.id, this.moderatingTweets).subscribe(
      state => {
        this.tweetModerationDone();
      }
    );
  }

  refuseTweetSelected() {
    this.businessService.moderateRefuseTweets(this.event.id, this.moderatingTweets).subscribe(
      state => {
        this.tweetModerationDone();
      }
    );
  }

  moderationDone() {
    this.picturesModel = this.picturesModel.filter(picture => {
      return this.moderatingPictures.indexOf(picture.id) == -1;
    });

    this.picturePage.totalElements -= this.moderatingPictures.length;
    this.moderatingPictures = [];

    this.loadPictures(1);
  }

  tweetModerationDone() {
    this.tweetsModel = this.tweetsModel.filter(tweet => {
      return this.moderatingTweets.indexOf(tweet.id) == -1;
    });

    this.tweetPage.totalElements -= this.moderatingTweets.length;
    this.moderatingTweets = [];

    this.loadTweets(1);
  }

  launchFetching() {
    let that = this;
    this.refreshIntervalId = setInterval(function () {
      that.loadIntervalPictures();
      that.loadIntervalTweets();
    }, 10000);
  }

  changeTab(tab: string) {
    this.showingTab = tab;

    if(tab=='photos') {
      this.renderFlexImages();
    }
  }

}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./~/tslint-loader?{"configFile":"tslint.json"}!./src/app/components/event/event-validation/event-validation.component.ts